import { render } from "./Home.vue?vue&type=template&id=cffaa79c&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=cffaa79c&lang=less&scoped=true"

import exportComponent from "/Users/jingshushu/homework/movie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffaa79c"]])

export default __exports__